<script lang="ts">
    import { Button, Nav, NavItem, NavLink } from "sveltestrap";
    import { Dashboard, Dropdownexample } from "../../../utils/Constant/Constant";
    import FeatherIcon from "svelte-feather-icon";
    import data from "../../../Data/ComponentData/Ui-kits/Navs/Navs.json"
</script>
<div class="onhover-dropdown navs-dropdown">
    <Button class="onhover-dropdown" color="primary">{Dropdownexample} <i class="icon-arrow-down"></i></Button>
    <div class="onhover-show-div">
        <Nav vertical class="icon-lists navs-icon">
            <NavItem>
                <NavLink active>
                    <FeatherIcon icon="home" />
                    <span> {Dashboard}</span>
                </NavLink>
            </NavItem>
            {#each data.activedropdown as navItem}
                <NavItem>
                    <NavLink disabled={navItem.class}> 
                        <FeatherIcon icon={navItem.icon} />
                        <span>{navItem.name}</span>
                    </NavLink>
                </NavItem>
            {/each}
        </Nav>
    </div>
</div>